import React from 'react';
import { Link } from 'react-router-dom';
import './ContentSection.css';

const ContentSection = ({ title, description, image, imageAlt, imageOnRight = false, ctaButton }) => {
  return (
    <section className={`content-section ${imageOnRight ? 'image-right' : 'image-left'}`}>
      <div className="content-container">
        <div className="content-image">
          <img src={image} alt={imageAlt} />
        </div>
        <div className="content-text">
          <h2>{title}</h2>
          <p>{description}</p>
          {ctaButton && (
            <Link to={ctaButton.link} className="cta-button">
              {ctaButton.text}
            </Link>
          )}
        </div>
      </div>
    </section>
  );
};

export default ContentSection; 